<app-status [isAvailable]="localPacsAvailable"></app-status>
